module.exports = __webpack_public_path__ + "static/img/eu.ab50940e.svg";